
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"data-name":"Ellipse 14","cx":"8","cy":"8","r":"8","fill":"#039be5"}}),_c('path',{attrs:{"data-name":"Path 79","d":"M4.1 7.438l7.628-2.631c.354-.114.663.077.549.556l-1.3 5.474c-.1.388-.354.482-.715.3l-1.978-1.3-.954.822a.521.521 0 01-.4.174l.14-1.8 3.666-2.963c.16-.126-.036-.2-.246-.071L5.96 8.551 4.01 8c-.424-.12-.433-.379.09-.562z","fill":"#fff"}})])
          )
        }
      }
    